import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcAppNavigationCaption = _resolveComponent("NcAppNavigationCaption")
  const _component_NavigationHint = _resolveComponent("NavigationHint")
  const _component_IconPhoneOutline = _resolveComponent("IconPhoneOutline")
  const _component_NcListItem = _resolveComponent("NcListItem")

  return ($props.value)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createVNode(_component_NcAppNavigationCaption, {
          name: $options.t('spreed', 'Phone numbers')
        }, null, 8, ["name"]),
        ($options.errorHint)
          ? (_openBlock(), _createBlock(_component_NavigationHint, {
              key: 0,
              hint: $options.errorHint
            }, null, 8, ["hint"]))
          : _createCommentVNode("", true),
        ($options.libPhoneNumber)
          ? (_openBlock(), _createBlock(_component_NcListItem, {
              key: 1,
              name: $props.name,
              onClick: $options.selectPhoneNumber
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconPhoneOutline, {
                  size: $setup.AVATAR.SIZE.DEFAULT
                }, null, 8, ["size"])
              ]),
              subname: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.participantPhoneItem.phoneNumber), 1)
              ]),
              _: 1
            }, 8, ["name", "onClick"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}